exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vuetify-avatar-selector{margin-bottom:20px}.avatar-image{margin-top:29px}.avatar-cursor{cursor:pointer}.avatar-content{margin-top:25px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-avatar-card.vue"],"names":[],"mappings":"AACA,yBACE,kBAAoB,CACrB,AACD,cACE,eAAiB,CAClB,AACD,eACE,cAAgB,CACjB,AACD,gBACE,eAAiB,CAClB","file":"vuetify-avatar-card.vue","sourcesContent":["\n.vuetify-avatar-selector {\n  margin-bottom: 20px;\n}\n.avatar-image {\n  margin-top: 29px;\n}\n.avatar-cursor {\n  cursor: pointer;\n}\n.avatar-content {\n  margin-top: 25px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7a2fcbe","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vuetify-avatar-card.vue
// module id = 627
// module chunks = 0 1 2 3 4 5